(function () {
  "use strict";

  if (window.LumaryPageFlyCartBridge || !window.LumaryCartCoordinator) {
    return;
  }

  var coordinator = window.LumaryCartCoordinator;
  var buttonSelector =
    '[data-pf-type="ProductATC2"], [data-universal-type="ProductATC2"]';
  var replayedButtons = new WeakSet();
  var buttonStates = new WeakMap();
  var intentQueue = [];
  var currentIntent = null;
  var activeBarrier = null;
  var batchHeld = false;
  var batchGeneration = 0;
  var idleWaiters = [];
  var requestStartTimeout = 6000;
  var requestCompletionTimeout = 25000;
  var stats = {
    captured: 0,
    completed: 0,
    failed: 0,
    maxQueue: 0,
    batchTotal: 0,
    batchConfirmed: 0,
    batchFailed: 0,
  };

  function notifyCoordinator() {
    if (typeof coordinator.notifyExternalStateChange === "function") {
      coordinator.notifyExternalStateChange();
    }
  }

  function getRequestUrl(input) {
    if (typeof input === "string") {
      return input;
    }
    if (input && typeof input.url === "string") {
      return input.url;
    }
    return "";
  }

  function isCartAddRequest(input, init) {
    var requestUrl = getRequestUrl(input);
    var method = String(
      (init && init.method) || (input && input.method) || "GET"
    ).toUpperCase();
    if (method !== "POST" || !requestUrl) {
      return false;
    }
    try {
      var url = new URL(requestUrl, window.location.origin);
      return (
        url.origin === window.location.origin &&
        /\/cart\/add\.js$/.test(url.pathname)
      );
    } catch (error) {
      return false;
    }
  }

  function getButtonSnapshot(button) {
    return {
      html: button.innerHTML,
      disabled: button.disabled,
      ariaBusy: button.getAttribute("aria-busy"),
      loading: button.classList.contains("is-loading"),
    };
  }

  function restoreAttribute(element, name, value) {
    if (value === null) {
      element.removeAttribute(name);
    } else {
      element.setAttribute(name, value);
    }
  }

  function setQueuedState(intent) {
    intent.button.classList.add("is-loading");
    intent.button.setAttribute("aria-busy", "true");
    intent.button.setAttribute("data-lumary-cart-queued", "");
  }

  function reserveButton(button) {
    var state = buttonStates.get(button);
    if (!state) {
      state = {
        snapshot: getButtonSnapshot(button),
        pending: 0,
      };
      buttonStates.set(button, state);
    }
    state.pending += 1;
    return state.snapshot;
  }

  function releaseButton(intent, restore) {
    if (!intent || !intent.button) {
      return;
    }
    var state = buttonStates.get(intent.button);
    if (restore) {
      restoreButton(intent);
    }
    if (!state) {
      return;
    }
    state.pending = Math.max(0, state.pending - 1);
    if (state.pending === 0) {
      buttonStates.delete(intent.button);
    }
  }

  function prepareButtonForReplay(intent) {
    intent.button.disabled = intent.snapshot.disabled;
    intent.button.classList.toggle("is-loading", intent.snapshot.loading);
    restoreAttribute(intent.button, "aria-busy", intent.snapshot.ariaBusy);
    intent.button.removeAttribute("data-lumary-cart-queued");
  }

  function restoreButton(intent) {
    if (!intent || !intent.button || !intent.button.isConnected) {
      return;
    }
    intent.button.innerHTML = intent.snapshot.html;
    intent.button.disabled = intent.snapshot.disabled;
    intent.button.classList.toggle("is-loading", intent.snapshot.loading);
    restoreAttribute(intent.button, "aria-busy", intent.snapshot.ariaBusy);
    intent.button.removeAttribute("data-lumary-cart-queued");
  }

  function clearIntentTimers(intent) {
    window.clearTimeout(intent.requestTimer);
    window.clearTimeout(intent.completionTimer);
    if (intent.observer) {
      intent.observer.disconnect();
    }
  }

  function holdBatch() {
    if (!batchHeld) {
      stats.batchTotal = 0;
      stats.batchConfirmed = 0;
      stats.batchFailed = 0;
      if (typeof coordinator.beginUserCartBatch === "function") {
        batchGeneration = coordinator.beginUserCartBatch();
      }
      coordinator.holdRefresh("pagefly");
      batchHeld = true;
      notifyCoordinator();
    }
  }

  function isBarrier(entry) {
    return !!(entry && entry.type === "barrier");
  }

  function queuedIntentCount() {
    return intentQueue.reduce(function (total, entry) {
      return total + (isBarrier(entry) ? 0 : 1);
    }, 0);
  }

  function getLatestPendingBarrier() {
    for (var index = intentQueue.length - 1; index >= 0; index -= 1) {
      if (isBarrier(intentQueue[index])) {
        return intentQueue[index];
      }
    }
    return activeBarrier;
  }

  function releaseBatchIfIdle() {
    if (currentIntent || activeBarrier || intentQueue.length > 0) {
      return;
    }
    if (batchHeld) {
      coordinator.releaseRefresh("pagefly");
      batchHeld = false;
      batchGeneration = 0;
      notifyCoordinator();
    }
    var waiters = idleWaiters.slice();
    idleWaiters = [];
    waiters.forEach(function (resolve) {
      resolve();
    });
  }

  function settleIntentProgress(intent, failed) {
    if (!intent || intent.progressSettled) {
      return;
    }
    intent.progressSettled = true;
    if (failed) {
      stats.batchFailed += 1;
    } else {
      stats.batchConfirmed += 1;
    }
    notifyCoordinator();
  }

  function finishCurrentIntent() {
    var intent = currentIntent;
    if (!intent) {
      return;
    }
    clearIntentTimers(intent);
    settleIntentProgress(intent, !!intent.failureType);
    releaseButton(intent, false);
    currentIntent = null;
    stats.completed += 1;
    if (intentQueue.length > 0) {
      startNextIntent();
    } else {
      releaseBatchIfIdle();
    }
  }

  function failBatch(failureType, message, recoveryAlreadyShown) {
    var failedIntent = currentIntent;
    var failedGeneration = failedIntent
      ? failedIntent.generation
      : batchGeneration;
    if (failedIntent) {
      settleIntentProgress(failedIntent, true);
      clearIntentTimers(failedIntent);
      releaseButton(failedIntent, true);
      currentIntent = null;
    }
    intentQueue.forEach(function (intent) {
      if (isBarrier(intent)) {
        intent.resolve(function () {});
        return;
      }
      settleIntentProgress(intent, true);
      releaseButton(intent, true);
    });
    intentQueue = [];
    stats.failed += 1;
    releaseBatchIfIdle();
    if (!recoveryAlreadyShown) {
      coordinator.showFailure(
        failureType || "request",
        message,
        failedIntent && failedIntent.button,
        failedGeneration
      );
    }
  }

  function observeCurrentButton(intent) {
    intent.observer = new MutationObserver(function () {
      if (intent.button.disabled && !intent.mutationSettled) {
        intent.sawDisabled = true;
        // PageFly may temporarily disable its own button. The capture handler
        // owns de-duplication, so keep it operable and queue every user click.
        intent.button.disabled = false;
      }
    });
    intent.observer.observe(intent.button, {
      attributes: true,
      attributeFilter: ["disabled"],
    });
  }

  function startNextIntent() {
    if (currentIntent || activeBarrier || intentQueue.length === 0) {
      releaseBatchIfIdle();
      return;
    }
    var intent = intentQueue.shift();
    if (isBarrier(intent)) {
      activeBarrier = intent;
      intent.resolve(function () {
        if (activeBarrier !== intent || intent.released) {
          return;
        }
        intent.released = true;
        activeBarrier = null;
        startNextIntent();
        releaseBatchIfIdle();
      });
      return;
    }
    if (intent.generation) {
      batchGeneration = intent.generation;
    }
    if (!intent.button.isConnected) {
      settleIntentProgress(intent, true);
      releaseButton(intent, false);
      stats.completed += 1;
      startNextIntent();
      return;
    }
    currentIntent = intent;
    prepareButtonForReplay(intent);
    observeCurrentButton(intent);
    replayedButtons.add(intent.button);
    intent.button.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    intent.sawDisabled = intent.button.disabled;
    intent.requestTimer = window.setTimeout(function () {
      if (currentIntent === intent && !intent.responseSeen) {
        failBatch("request", "");
      }
    }, requestStartTimeout);
    intent.completionTimer = window.setTimeout(function () {
      if (currentIntent === intent) {
        failBatch(intent.failureType || "timeout", intent.failureMessage || "");
      }
    }, requestCompletionTimeout);
  }

  function enqueueIntent(button) {
    var precedingBarrier = getLatestPendingBarrier();
    holdBatch();
    var intentGeneration = batchGeneration;
    if (precedingBarrier) {
      if (!precedingBarrier.nextGeneration) {
        precedingBarrier.nextGeneration =
          typeof coordinator.beginUserCartBatch === "function"
            ? coordinator.beginUserCartBatch()
            : batchGeneration;
      }
      intentGeneration = precedingBarrier.nextGeneration;
    }
    var intent = {
      button: button,
      snapshot: reserveButton(button),
      responseSeen: false,
      sawDisabled: false,
      fatalFailure: false,
      failureType: "",
      failureMessage: "",
      observer: null,
      requestTimer: null,
      completionTimer: null,
      progressSettled: false,
      mutationSettled: false,
      generation: intentGeneration,
    };
    setQueuedState(intent);
    intentQueue.push(intent);
    stats.captured += 1;
    stats.batchTotal += 1;
    stats.maxQueue = Math.max(
      stats.maxQueue,
      queuedIntentCount() + (currentIntent ? 1 : 0)
    );
    notifyCoordinator();
    startNextIntent();
  }

  document.addEventListener(
    "click",
    function (event) {
      var target = event.target;
      var button = target && target.closest ? target.closest(buttonSelector) : null;
      if (!button) {
        return;
      }
      if (replayedButtons.has(button)) {
        replayedButtons.delete(button);
        return;
      }
      if (button.disabled && !buttonStates.has(button)) {
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      enqueueIntent(button);
    },
    true
  );

  var pageFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    if (
      !currentIntent ||
      currentIntent.responseSeen ||
      !isCartAddRequest(input, init)
    ) {
      return pageFetch(input, init);
    }
    var intent = currentIntent;
    intent.responseSeen = true;
    window.clearTimeout(intent.requestTimer);
    var ticket = coordinator.enqueueFetch(input, init, {
      source: "pagefly",
      showCart: true,
      trigger: intent.button,
      resolveFailureResult: true,
      bundleSections: intentQueue.length === 0,
      visibilityGeneration: intent.generation,
    });
    return ticket.mutation.then(
      function (response) {
        intent.mutationSettled = true;
        if (intent.observer) {
          intent.observer.disconnect();
        }
        if (intent.sawDisabled && intent.button.isConnected) {
          // Restore the state PageFly set before its response continuation.
          // PageFly can then deliberately keep the button disabled (sold out)
          // or re-enable it in its own success/error handler.
          intent.button.disabled = true;
        }
        var failureType = coordinator.classifyFetchResponse(response);
        intent.failureType = failureType;
        intent.failureMessage = coordinator.getFailureMessage(
          failureType,
          response
        );
        settleIntentProgress(intent, !!failureType);
        if (failureType === "challenge" || failureType === "rate-limit") {
          intent.fatalFailure = true;
          window.setTimeout(function () {
            if (currentIntent === intent) {
              failBatch(failureType, intent.failureMessage, true);
            }
          }, 0);
        } else {
          window.setTimeout(function () {
            if (currentIntent === intent) {
              finishCurrentIntent();
            }
          }, 0);
        }
        return response;
      },
      function (error) {
        intent.mutationSettled = true;
        if (intent.observer) {
          intent.observer.disconnect();
        }
        if (intent.sawDisabled && intent.button.isConnected) {
          intent.button.disabled = true;
        }
        intent.fatalFailure = true;
        intent.failureType = coordinator.classifyError(error);
        intent.failureMessage = coordinator.getFailureMessage(
          intent.failureType,
          error
        );
        settleIntentProgress(intent, true);
        window.setTimeout(function () {
          if (currentIntent === intent) {
            failBatch(intent.failureType, intent.failureMessage, true);
          }
        }, 0);
        throw error;
      }
    );
  };

  window.LumaryPageFlyCartBridge = {
    enqueueBarrier: function () {
      return new Promise(function (resolve) {
        intentQueue.push({
          type: "barrier",
          released: false,
          nextGeneration: 0,
          resolve: resolve,
        });
        startNextIntent();
        notifyCoordinator();
      });
    },
    whenIdle: function () {
      if (!currentIntent && !activeBarrier && intentQueue.length === 0) {
        return Promise.resolve();
      }
      return new Promise(function (resolve) {
        idleWaiters.push(resolve);
      });
    },
    getStats: function () {
      return {
        captured: stats.captured,
        completed: stats.completed,
        failed: stats.failed,
        maxQueue: stats.maxQueue,
        batchTotal: stats.batchTotal,
        batchConfirmed: stats.batchConfirmed,
        batchFailed: stats.batchFailed,
        generation: batchGeneration,
        pending: queuedIntentCount() + (currentIntent ? 1 : 0),
        barrierActive: !!activeBarrier,
      };
    },
  };
})();
